import { render } from "./Creation_bu.vue?vue&type=template&id=1198f6c1"
import script from "./Creation_bu.vue?vue&type=script&lang=js"
export * from "./Creation_bu.vue?vue&type=script&lang=js"

import "./Creation_bu.vue?vue&type=style&index=0&id=1198f6c1&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
